export default __webpack_public_path__ + "static/media/three_color_drink_thumbnail.79bed76e.JPG";